var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.284,
    height: 28.284,
    viewBox: "0 0 28.284 28.284",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(14.142) rotate(45)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Area",
    width: 20,
    height: 20,
    fill: "#fcfcfc",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon-2",
    "data-name": "Icon",
    transform: "translate(1.667 1.667)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line",
    x1: 9.167,
    y2: 9.167,
    transform: "translate(7.5 0)",
    fill: "none",
    stroke: "gold",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.667
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M16.666,0,10.833,16.666,7.5,9.166,0,5.833Z",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "gold",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.667
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.7c98d7f1ca17fa27f83912bc7d590117.svg";
export { ForwardRef as ReactComponent };